import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FeePayment } from '../fee-payment.model';


@Component({
  selector: 'additional-details',
  templateUrl: './additional-details.component.html'
})
export class AdditionalDetailsComponent {

  v10: boolean;
  SelectedFP:FeePayment;
  dateCheck:string = '0001-01-01T00:00:00';

  constructor( private dialogRef: MatDialogRef<AdditionalDetailsComponent>,
                @Inject(MAT_DIALOG_DATA) private data: any) {

  }

  ngOnInit() {
    this.SelectedFP = this.data.SelectedFP;
    this.v10 = this.data.v10;
  }

  closeClick(){
    this.dialogRef.close('Close was clicked.');
  }

}
